import { useState, useCallback } from "react";

interface GeocodedLocation {
  city: string;
  state?: string;
  country?: string;
}

export function useReverseGeocode() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reverseGeocode = useCallback(
    async (lat: number, lng: number): Promise<GeocodedLocation | null> => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
          {
            headers: {
              "User-Agent": "FlexTrack/1.0",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Geocoding failed");
        }

        const data = await response.json();
        const address = data.address;

        // Try to get city from various fields
        const city =
          address.city ||
          address.town ||
          address.village ||
          address.municipality ||
          address.county ||
          "Unknown";

        return {
          city,
          state: address.state,
          country: address.country,
        };
      } catch (err) {
        setError(err instanceof Error ? err.message : "Geocoding failed");
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { reverseGeocode, isLoading, error };
}
